var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpdateIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#E7F2F4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5132_23260)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.6667 18.666V21.9993C22.6667 22.1762 22.5964 22.3457 22.4714 22.4707C22.3464 22.5958 22.1768 22.666 22 22.666H10C9.82319 22.666 9.65362 22.5958 9.5286 22.4707C9.40357 22.3457 9.33333 22.1762 9.33333 21.9993V18.666H8V21.9993C8 22.5298 8.21071 23.0385 8.58579 23.4136C8.96086 23.7886 9.46957 23.9993 10 23.9993H22C22.5304 23.9993 23.0391 23.7886 23.4142 23.4136C23.7893 23.0385 24 22.5298 24 21.9993V18.666H22.6667Z",
    fill: "#0D8091"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9785 7.99952C15.716 7.9988 15.4559 8.04989 15.2131 8.14988C14.9704 8.24986 14.7497 8.39677 14.5638 8.58219L11.9512 11.1949L12.8938 12.1375L15.3165 9.71552L15.3338 20.6662H16.6672L16.6498 9.72485L19.0625 12.1375L20.0052 11.1949L17.3925 8.58219C17.2068 8.39679 16.9862 8.24989 16.7436 8.1499C16.5009 8.04991 16.2409 7.99881 15.9785 7.99952Z",
    fill: "#0D8091"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5132_23260"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdateIcon);
export default __webpack_public_path__ + "static/media/UpdateIcon.d52023ca47cc08b6b8420f6223c8781f.svg";
export { ForwardRef as ReactComponent };